"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const schema_1 = require("../schema");
const systems_1 = require("@/store/ducks/systems");
const selectors_1 = require("@/store/ducks/systems/selectors");
const selectors_2 = require("@/store/ducks/sites/selectors");
const index_view_1 = __importDefault(require("../index.view"));
const editSystemUseCase_1 = __importDefault(require("@/useCases/systems/editSystemUseCase"));
function openAddSystemModal() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isEditSystemtModalVisible = (0, react_redux_1.useSelector)(selectors_1.isEditSystemModalOpenSelector);
    const sitesOptions = (0, react_redux_1.useSelector)(selectors_2.sitesListOptionsSelector);
    const isLoading = (0, react_redux_1.useSelector)(selectors_1.isSavingSystemSelector);
    const systemToBeEdited = (0, react_redux_1.useSelector)(selectors_1.systemToBeEditedSelector);
    const onCloseModal = react_1.default.useCallback(() => {
        dispatch((0, systems_1.closeEditSystemModal)());
    }, [dispatch, systems_1.closeEditSystemModal]);
    const initialValues = {
        name: systemToBeEdited?.name,
        site: {
            value: systemToBeEdited?.siteId,
            label: systemToBeEdited?.siteName,
        },
    };
    const onSubmit = (values) => {
        (0, editSystemUseCase_1.default)(systemToBeEdited?.id, {
            name: values.name,
            siteId: values.site.value,
        })(dispatch);
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, enableReinitialize: true, validationSchema: schema_1.validationSchema, onSubmit: onSubmit }, (props) => {
        return (react_1.default.createElement(index_view_1.default, { formTitle: "Edit System", onBlur: props.handleBlur, values: props.values, options: sitesOptions, setFieldValue: props.setFieldValue, onSubmit: props.handleSubmit, errors: props.errors, confirmActionText: "Edit System", touched: props.touched, isLoading: isLoading, onChange: props.handleChange, onClose: onCloseModal, isOpen: isEditSystemtModalVisible }));
    }));
}
exports.default = openAddSystemModal;
